import { useState, useRef } from 'react';
import { TAGS } from '../../assets/mockData';
import { useUser } from '../../contexts/UserContext';
import { usePosts } from '../../contexts/PostContext';
import { compressImage, fileToDataURL } from '../../utils/imageCompress';
import ImageUploader from '../Common/ImageUploader';
import Modal from '../Common/Modal';

export default function PostCreate({ open, onClose }) {
  const [content, setContent] = useState('');
  const [images, setImages] = useState([]);
  const [video, setVideo] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [posting, setPosting] = useState(false);
  const videoRef = useRef();
  const { user } = useUser();
  const { addPost } = usePosts();

  const handleVideoSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    setVideo(url);
    setVideoPreview(url);
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const handleSubmit = async () => {
    if (!content.trim() && !images.length && !video) return;
    setPosting(true);

    await new Promise((r) => setTimeout(r, 500));

    addPost({
      userId: user.id,
      content: content.trim(),
      images,
      video,
      tags: selectedTags,
    });

    setContent('');
    setImages([]);
    setVideo(null);
    setVideoPreview(null);
    setSelectedTags([]);
    setPosting(false);
    onClose();
  };

  const reset = () => {
    setContent('');
    setImages([]);
    setVideo(null);
    setVideoPreview(null);
    setSelectedTags([]);
    onClose();
  };

  return (
    <Modal open={open} onClose={reset} title="发布动态">
      <div className="post-create">
        <textarea
          className="post-create-textarea"
          placeholder="分享你的想法、经历或发现..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows={4}
        />

        {!video && <ImageUploader images={images} onChange={setImages} />}

        {!images.length && (
          <div className="video-upload-area">
            {videoPreview ? (
              <div className="video-preview">
                <video src={videoPreview} controls />
                <button className="video-remove" onClick={() => { setVideo(null); setVideoPreview(null); }}>
                  移除视频
                </button>
              </div>
            ) : (
              <button className="video-add-btn" onClick={() => videoRef.current?.click()}>
                <svg viewBox="0 0 24 24" width="20" height="20">
                  <polygon points="23 7 16 12 23 17 23 7" fill="none" stroke="currentColor" strokeWidth="2" />
                  <rect x="1" y="5" width="15" height="14" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="2" />
                </svg>
                添加视频
              </button>
            )}
            <input
              ref={videoRef}
              type="file"
              accept="video/*"
              onChange={handleVideoSelect}
              style={{ display: 'none' }}
            />
          </div>
        )}

        <div className="tag-selector">
          <div className="tag-selector-label">选择标签：</div>
          <div className="tag-selector-list">
            {TAGS.map((tag) => (
              <button
                key={tag}
                className={`tag-option ${selectedTags.includes(tag) ? 'selected' : ''}`}
                onClick={() => toggleTag(tag)}
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>

        <button
          className="post-create-submit"
          onClick={handleSubmit}
          disabled={posting || (!content.trim() && !images.length && !video)}
        >
          {posting ? '发布中...' : '发布'}
        </button>
      </div>
    </Modal>
  );
}
